export default [
  {
    for: 'sftp-user',
    actions: {
      update: true,
      read: true,
    },
  },
];
